/*
 * @Author: v-chenxiong v-chenxiong@xiaomi.com
 * @Date: 2026-09-17 00:00:00
 * @LastEditors: v-chenxiong v-chenxiong@xiaomi.com
 * @LastEditTime: 2026-09-17 00:00:00
 * @FilePath: /RetailApp/retail-global-h5/src/pages/RetailGlobal/Protocol/VoiceRecordingConsent/VN/index.tsx
 * @Description: 语音作答知情同意书（越南：越南语 + 英语）
 */
import React from 'react';
import globalStyles from '../../../global.less';
import styles from './index.less';
import protocol from './protocol'
import { useParams } from "react-router-dom";


function VoiceRecordingConsent() {

    const { country = 'GLOBAL' } = useParams()
    const HTML_CONTENT = protocol[country] || protocol['GLOBAL'];

    return (
        <div className={[globalStyles['container'], styles['viewport']].join(' ')}>
            <div dangerouslySetInnerHTML={{ __html: HTML_CONTENT }} />
        </div>
    )
}

export default VoiceRecordingConsent
